// extracted by mini-css-extract-plugin
export default {"wrapper":"Components_wrapper__LDUH+"};